import script from "./MoedasCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./MoedasCadastro.vue?vue&type=script&setup=true&lang=js"

import "./MoedasCadastro.vue?vue&type=style&index=0&id=69c0882c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69c0882c"]])

export default __exports__